import {BasicManagedFile} from './basicManagedFile'
import {OA_MARK, OA_PROJ} from '../Data/typeDirs'
// import {
//   getFullDropboxDirListing
// } from '../Services/dropbox'
import OAMarker from './oaMarker'
import { PROJ } from '../Services/openAsset/structures'
// import { openAsset } from '../Services/openAsset'
const openAsset = {}
const ARCHDIR = '/Archive'

class OAProject extends BasicManagedFile {
  constructor(data){
    super(data)
    this.ext = 'oa_proj'
    this.typeDir= OAProject.getTypeDir()
    this.dirName = data.dirName || data.name


    // this.construct(data)
  }

  construct(data){
    super.construct(data)
    this.version = this.version?this.version:1
    this.name = data.name
    this.oa_id = data.oa_id
    // this._name = data._id
    this.dirName = data.dirName || data.name
    return this
  }

  serialize(){
    let superSerialized = super.serialize()
    let {oa_id, dirName} = this
    return {...superSerialized, oa_id, dirName}
  }

  getTree(){
    return this.content.content.oa_data.tree
  }

  static getOASchema(){
      return [
        {label: 'Name', name: "name", type:'text', options:[]},
        {label: 'id', name: "id", type:'text', options:[]},
        {label: 'Code', name: "code", type:'text', options:[]},
        {label: 'Created', name: "created", type:'text', options:[]},
      ]
  }

  static getOAProjectFromOAData(oaData){
    let {name, oa_id, code, oa_created} = oaData
    return new OAProject({content:{
      oa_data:{
        tree:{
          name:{content: [{_name:name}]},
          id:{content: [{_name:`${oa_id}`}]},
          code:{content: [{_name:code}]},
          created:{content: [{_name:oa_created}]}
        },
        schema: OAProject.getOASchema(),
        source:{}
      }
    }, name, oa_id:oa_id, dirName: name + "-" + oa_created})
  }

  static getExt(){
    return 'oa_proj'
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},oa_id,dirName`
  }

  static getTypeDir(){
    return OA_PROJ
  }



  getDropboxDir(){
    return `${ARCHDIR}/${OA_PROJ}/${this.dirName}`
  }

  getDataForOpenAsset(){
    let tree = this.getTree()
    let res = {}
    for(let key of Object.keys(tree)){
      if(Array.isArray(tree[key].content)){
        res[key] = tree[key].content[0]._name 
      }else res[key] = tree[key].content
    }

    return res
  }

  async putToOpenAsset(get, put, user){

    
    let data = this.getDataForOpenAsset()
    console.log('attempting to put data to oa \n', data, '\n')
    let res = await openAsset[PROJ].put(data)
    // let newContent = OAProject.getOAProjectFromOAData(res)
    // this.content = newContent.content
    // await put(OA_PROJ, this.serialize(), user, true)

    // let marks = await get(OA_MARK, {_project: this._id}, user)
    // for(let mark of marks){
    //   mark = new OAMarker(mark)
    //   mark.updateProjectId(res.project_id)
    //   await put(OA_MARK, mark.serialize(), user, true)
    // }

    console.log('res from put\n', res, '\n')


  }



  // async countDropboxPhotos(getList = false){
  //   let res = await getFullDropboxDirListing(`${this.getDropboxDir()}/photos`)
  //   console.log('got res from dbx listing', res)
  //   if(getList) return res
    
  //   return res.length
  // }

  static async killLocalDBRecords(localDb, name, _id){
    let marks = await localDb[OA_MARK].where({_project: _id}).then(res=>res.toArray())
    console.log('marks to array killing us all', marks)
    // marks = await marks.toArray()
    // console.log('after', marks)

    for(let mark of marks){
      await localDb[OA_MARK].kill({_id:mark._id})
    }

    await localDb[OA_PROJ].kill({_id})
  }

  static async delete(fileModels, _id){
    let {Main, Versions} = fileModels[OA_PROJ]
    let marks = await fileModels[OA_MARK].Main.find({_project: _id})

    for(let mark of marks){
      try{
        OAMarker.delete(fileModels, mark._id)        
      }catch(e){
        console.log('failed deleting OA_MARK in OA_PROJ', _id, mark._id, e)

      }
    }

    try{
      await Main.findOneAndDelete({_id}).exec()
      await Versions.deleteMany({_parentId:_id}).exec()
    }catch(e){
      console.log('failed deleting OA_PROJ', _id, e)
    }
  
  }

  getCreatedDate(){
    let oaDate = this.getTree().created.content[0]._name
    console.log('going to create date', oaDate)
    return OAProject.getOACreatedDateString(oaDate)
  }

  static getOACreatedDateString(oaDate){
    if (!oaDate) return ''
    let year = oaDate.slice(0, 4)
    let month = `${parseInt(oaDate.slice(4, 5)) - 1}`
    let day = oaDate.slice(6, 7)
    let hour = oaDate.slice(8, 9)
    let min = oaDate.slice(10, 11)
    let sec = oaDate.slice(12)
    let date = new Date(year, month, day, hour, min, sec)
    // console.log('got date data', oaDate, year, month, day, hour, min, sec, date)
    return date.toLocaleDateString()

  }

  // async getDropboxPhotoIdList(){
  //   let dir = `${ARCHDIR}/${OA_PROJ}/${this.dirName}/photos/`
  //   let res
  //   try{
  //     res = await getFullDropboxDirListing(dir)
  //   }catch(e){
  //     console.log('failed getting dropbox dir listing for oa proj', e)
  //     return []
  //   }
  //   console.log('got res', res)
  //   if(!res) return []
  //   return res.map(itm=>{
  //     return itm.split('/')[itm.split('/').length-1].split('.')[0]
  //   })

  // }

  // static async archive(fileModels, _id, repMarkToArchive){
  //   let {Main, Archive, Versions} = fileModels[OA_PROJ]
  //
  //   let repMarkArchiveCreateRes,
  //     repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToArchive?', repMarkToArchive)
  //     if(!repMarkToArchive) repMarkToArchive = await Main.findOne({_id}).exec()
  //     console.log('got repMarkToArchive', repMarkToArchive)
  //     repMarkArchiveCreateRes = await Archive.findOneAndUpdate({_id}, repMarkToArchive, {upsert:true}).exec()
  //     console.log('got repMarkArchiveCreateRes')
  //     repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed archiving repMark',
  //       repMarkArchiveCreateRes,
  //       repMarkVersionsDeleteManyRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToArchive
  // }
  //
  // static async delete(fileModels, _id, repMarkToDelete){
  //   let {Main, Delete, Versions} = fileModels[OA_PROJ]
  //
  //   let repMarkDeleteCreateRes,
  //     repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToDelete?', repMarkToDelete)
  //     if(!repMarkToDelete) repMarkToDelete = await Main.findOne({_id}).exec()
  //     console.log('got repMarkToDelete', repMarkToDelete)
  //     // repMarkDeleteCreateRes = await Delete.findOneAndUpdate({_id}, repMarkToDelete, {upsert:true}).exec()
  //     // console.log('got repMarkDeleteCreateRes')
  //     repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed delete repMark',
  //       repMarkDeleteCreateRes,
  //       repMarkVersionsDeleteManyRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToDelete
  // }
  //
  //
  // static async unarchive(fileModels, _id, repMarkToUnarchive){
  //   let {Main, Archive, Versions} = fileModels[OA_PROJ]
  //
  //   let repMarkUnarchiveCreateRes,
  //     // repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToArchive?', repMarkToArchive)
  //     if(!repMarkToUnarchive) repMarkToUnarchive = await Archive.findOne({_id}).exec()
  //     console.log('got repMarkToUnarchive', repMarkToUnarchive)
  //     repMarkUnarchiveCreateRes = await Main.findOneAndUpdate({_id}, repMarkToUnarchive, {upsert:true}).exec()
  //     console.log('got repMarkUnarchiveCreateRes')
  //     // repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     // console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Archive.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed archiving repMark',
  //       repMarkUnarchiveCreateRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToUnarchive
  // }

  // static async killLocalDBRecords(localdb, _id){
  //   let res = await localdb[OA_PROJ].kill({_id})
  //   console.log('killing db record for repMarker', _id, res)
  //   return res
  // }
}

export default OAProject
